import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const leavesApi = {
  getAll: (params) => api.get('/leaves', { params }).then(unwrap),
  apply: (data) => api.post('/leaves', data).then(unwrap),
  review: (id, data) => api.put(`/leaves/${id}/review`, data).then(unwrap),
}
